// extracted by mini-css-extract-plugin
export default {"item":"Autofill_item__cY0CC","condensed":"Autofill_condensed__dYVhe","icon":"Autofill_icon__9NMJ1","name":"Autofill_name__xR3Ay","arrow":"Autofill_arrow__V-Vpq"};